import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { OriginalGame } from '@/types/original'
import type { RootState } from '@/store/store'

interface OriginalState {
	favoriteIds: string[]
	playGame: OriginalGame | null
}

const initialState: OriginalState = {
	favoriteIds: [],
	playGame: null,
}

const originalSlice = createSlice({
	name: 'original',
	initialState,
	reducers: {
		toggleFavorite(state, action: PayloadAction<string>) {
			const gameId = action.payload
			const index = state.favoriteIds.indexOf(gameId)

			if (index >= 0) {
				state.favoriteIds.splice(index, 1)
				return
			}

			state.favoriteIds.push(gameId)
		},
		setPlayGame(state, action: PayloadAction<OriginalGame>) {
			state.playGame = action.payload
		},
		clearPlayGame(state) {
			state.playGame = null
		},
	},
})

export const { toggleFavorite, setPlayGame, clearPlayGame } = originalSlice.actions

export const selectFavoriteIds = (state: RootState) => state.original.favoriteIds

export const selectIsOriginalFavorite = (gameId: string) => (state: RootState) => state.original.favoriteIds.includes(gameId)

export const selectPlayGame = (state: RootState) => state.original.playGame

export default originalSlice.reducer
